import axios from 'axios';

class Sms {
  static loadImageCode() {
    return axios.get('https://cj.tibaitong.com/api/sms/loadImageCode');
  }

  static sendCode(imageCode, phone) {
    return axios({
      method: 'get',
      url: 'https://cj.tibaitong.com/api/sms/sendSmsCode',
      params: {
        imageCode,
        phone,
      },
    });
  }

  static validateCode(phone, smsCode) {
    return axios({
      method: 'get',
      url: 'https://cj.tibaitong.com/api/sms/validSmsCode',
      params: {
        phone,
        smsCode,
      },
    });
  }
}

export default Sms;
